// NB: This file is allowed to import 'shared/verifications/checks.json' directly.
// eslint-disable-next-line no-restricted-imports
import checkProperties from 'shared/verifications/checks.json';

import { VERIFICATION_TYPE_CHECK_TYPE } from 'dashboard/lib/constants/verification';
import { CheckProperties } from 'dashboard/models/verification-check';
import {
  VerificationTemplateVersion,
  VTMPLV_VERIFICATION_TYPE_MAP,
} from 'dashboard/models/verification-template-version';

const CHECK_PROPERTIES = checkProperties as CheckProperties;

// TODO(lucas): Harmonize this with VERIFICATION_TYPE_NAMES. They're technically Verification Types.
export enum CheckType {
  Aamva = 'aamva',
  BusinessWebsite = 'business_website',
  CertificateKorea = 'certificate_korea',
  Database = 'database',
  DatabaseAadhaar = 'database_aadhaar',
  DatabaseBusiness = 'database_business',
  DatabaseBusinessFootprint = 'database_business_footprint',
  DatabaseEcbsv = 'database_ecbsv',
  DatabasePhoneCarrier = 'database_phone_carrier',
  DatabaseSerpro = 'database_serpro',
  DatabaseStandard = 'database_standard',
  DatabaseTin = 'database_tin',
  DatabaseVatNumber = 'database_vat_number',
  DigitalIdFinnishTrustNetwork = 'digital_id_finnish_trust_network',
  DigitalIdOneId = 'digital_id_one_id',
  DigitalIdSingpass = 'digital_id_singpass',
  DigitalIdUkSharecode = 'digital_id_uk_sharecode',
  Document = 'document',
  EmailAddress = 'email_address',
  Id = 'id',
  IdNfc = 'id_nfc',
  MobileDriversLicense = 'mobile_drivers_license',
  PhoneNumber = 'phone_number',
  Selfie = 'selfie',
}

// TODO: This should live in front-end/lib/constants/check.ts and/or be generated.
export enum CheckName {
  AamvaAddressComparison = 'aamva_address_comparison',
  AamvaBirthdateComparison = 'aamva_birthdate_comparison',
  AamvaExpirationDateComparison = 'aamva_expiration_date_comparison',
  AamvaIdentificationNumberComparison = 'aamva_identification_number_comparison',
  AamvaIdentityComparison = 'aamva_identity_comparison',
  AamvaIssueDateComparison = 'aamva_issue_date_comparison',
  AamvaNameComparison = 'aamva_name_comparison',
  AamvaServiceAvailableDetection = 'aamva_service_available_detection',

  BusinessWebsiteDomainAgeDetection = 'business_website_domain_age_detection',
  BusinessWebsiteDomainExpirationDetection = 'business_website_domain_expiration_detection',
  BusinessWebsiteDomainResolvableDetection = 'business_website_domain_resolvable_detection',
  BusinessWebsiteSufficientContentDetection = 'business_website_sufficient_content_detection',
  BusinessWebsiteIdentityComparison = 'business_website_identity_comparison',
  BusinessWebsiteWebsiteComparison = 'business_website_website_comparison',

  CertificateKoreaBirthdateComparison = 'certificate_korea_birthdate_comparison',
  CertificateKoreaIdentificationNumberComparison = 'certificate_korea_identification_number_comparison',
  CertificateKoreaNameComparison = 'certificate_korea_name_comparison',
  CertificateKoreaPkiFailureDetection = 'certificate_korea_pki_failure_detection',

  DatabaseAddressComparison = 'database_address_comparison',
  DatabaseAddressDeliverableDetection = 'database_address_deliverable_detection',
  DatabaseAddressResidentialDetection = 'database_address_residential_detection',
  DatabaseAttributeComparison = 'database_attribute_comparison',
  DatabaseBirthdateComparison = 'database_birthdate_comparison',
  DatabaseDeceasedDetection = 'database_deceased_detection',
  DatabaseIdentityComparison = 'database_identity_comparison',
  DatabaseInquiryComparison = 'database_inquiry_comparison',
  DatabaseNameComparison = 'database_name_comparison',
  DatabaseEmailAddressComparison = 'database_email_address_comparison',
  DatabasePhoneNumberComparison = 'database_phone_number_comparison',
  DatabasePoBoxDetection = 'database_po_box_detection',
  DatabaseSocialSecurityNumberComparison = 'database_social_security_number_comparison',
  DatabaseTwoPlusTwoDetection = 'database_two_plus_two_detection',

  DatabaseAadhaarNameComparison = 'database_aadhaar_name_comparison',
  DatabaseAadhaarBirthdateComparison = 'database_aadhaar_birthdate_comparison',
  DatabaseAadhaarConsentCheck = 'database_aadhaar_consent_check',

  DatabaseBusinessActiveBusinessDetection = 'database_business_active_business_detection',
  DatabaseBusinessAssociatedPersonsComparison = 'database_business_associated_persons_comparison',
  DatabaseBusinessAiIdentityComparison = 'database_business_ai_identity_comparison',
  DatabaseBusinessEnabledCountryDetection = 'database_business_enabled_country_detection',
  DatabaseBusinessIdentityComparison = 'database_business_identity_comparison',
  DatabaseBusinessValidRegistrationNumberFormat = 'database_business_valid_registration_number_format',

  DatabaseBusinessFootprintEnabledCountryDetection = 'database_business_footprint_enabled_country_detection',
  DatabaseBusinessFootprintIdentityComparison = 'database_business_footprint_identity_comparison',

  DatabaseEcbsvRecordMatch = 'database_ecbsv_record_match',
  DatabaseEcbsvDeathRecord = 'database_ecbsv_death_record',
  DatabaseEcbsvServiceAvailableDetection = 'database_ecbsv_service_available_detection',

  DatabasePhoneCarrierNameFirstComparison = 'database_phone_carrier_name_first_comparison',
  DatabasePhoneCarrierNameLastComparison = 'database_phone_carrier_name_last_comparison',
  DatabasePhoneCarrierAddressComparison = 'database_phone_carrier_address_comparison',
  DatabasePhoneCarrierBirthdateComparison = 'database_phone_carrier_birthdate_comparison',
  DatabasePhoneCarrierServiceAvailableDetection = 'database_phone_carrier_service_available_detection',

  DatabaseStandardIdentityComparison = 'database_standard_identity_comparison',

  DatabaseSerproBirthdateComparison = 'database_serpro_birthdate_comparison',
  DatabaseSerproCpfComparison = 'database_serpro_cpf_comparison',
  DatabaseSerproFaceComparison = 'database_serpro_face_comparison',
  DatabaseSerproNameComparison = 'database_serpro_name_comparison',
  DatabaseSerproServiceAvailableDetection = 'database_serpro_service_available_detection',

  DatabaseTinDeceasedDetection = 'database_tin_deceased_detection',
  DatabaseTinDisallowedTypeDetection = 'database_tin_disallowed_type_detection',
  DatabaseTinInvalidFormatDetection = 'database_tin_invalid_format_detection',
  DatabaseTinServiceAvailableDetection = 'database_tin_service_available_detection',
  DatabaseTinNameComparison = 'database_tin_name_comparison',

  DatabaseVatNumberIdentityComparison = 'database_vat_number_identity_comparison',
  DatabaseVatNumberValidDetection = 'database_vat_number_valid_detection',
  DatabaseVatNumberServiceAvailableDetection = 'database_vat_number_service_available_detection',

  DigitalIdFinnishTrustNetworkServiceAvailableDetection = 'digital_id_finnish_trust_network_service_available_detection',

  DigitalIdOneIdFlowCompletedDetection = 'digital_id_one_id_flow_completed_detection',
  DigitalIdOneIdServiceAvailableDetection = 'digital_id_one_id_service_available_detection',

  DigitalIdSerproServiceAvailableDetection = 'digital_id_serpro_service_available_detection',
  DigitalIdSerproIdentityComparison = 'digital_id_serpro_identity_comparison',
  DigitalIdSerproSelfieComparison = 'digital_id_serpro_selfie_comparison',
  DigitalIdSingpassFlowCompletedDetection = 'digital_id_singpass_flow_completed_detection',

  DigitalIdUkSharecodeIdentityComparison = 'digital_id_uk_sharecode_identity_comparison',
  DigitalIdUkSharecodeExpiredDetection = 'digital_id_uk_sharecode_expired_detection',
  DigitalIdUkSharecodeNameComparison = 'digital_id_uk_sharecode_name_comparison',
  DigitalIdUkSharecodeRightToWorkDetection = 'digital_id_uk_sharecode_right_to_work_detection',
  DigitalIdUkSharecodeServiceAvailableDetection = 'digital_id_uk_sharecode_service_available_detection',

  DocumentColorModeDetection = 'document_color_mode_detection',
  DocumentCompromisedDetection = 'document_compromised_detection',
  DocumentDigitalTextModificationDetection = 'document_digital_text_modification_detection',
  DocumentExpiredDetection = 'document_expired_detection',
  DocumentExtractedPropertiesDetection = 'document_extracted_properties_detection',
  DocumentFabricationDetection = 'document_fabrication_detection',
  DocumentHandwritingDetection = 'document_handwriting_detection',
  DocumentImageCopyMoveDetection = 'document_image_copy_move_detection',
  DocumentImageInconsistentTimestampDetection = 'document_image_inconsistent_timestamp_detection',
  DocumentImageSuspiciousMetadataDetection = 'document_image_suspicious_metadata_detection',
  DocumentJpegOriginalImageDetection = 'document_jpeg_original_image_detection',
  DocumentPdfAbnormalFontDetection = 'document_pdf_abnormal_font_detection',
  DocumentPdfAnnotationDetection = 'document_pdf_annotation_detection',
  DocumentPdfContentTypeDetection = 'document_pdf_content_type_detection',
  DocumentPdfEditorDetection = 'document_pdf_editor_detection',
  DocumentPdfInconsistentTimestampDetection = 'document_pdf_inconsistent_timestamp_detection',
  DocumentPdfModificationDetection = 'document_pdf_modification_detection',
  DocumentPortraitDetection = 'document_portrait_detection',
  DocumentRecencyDetection = 'document_recency_detection',
  DocumentSelfieComparison = 'document_selfie_comparison',
  DocumentSyntheticContentDetection = 'document_synthetic_content_detection',
  DocumentTamperDetection = 'document_tamper_detection',
  DocumentTemplateDetection = 'document_template_detection',
  DocumentTypeDetection = 'document_type_detection',
  DocumentUnprocessableSubmissionDetection = 'document_unprocessable_submission_detection',

  EmailAddressConfirmationCodeComparison = 'email_address_confirmation_code_comparison',
  EmailAddressTimeoutDetection = 'email_address_timeout_detection',
  EmailAddressInvalidEmailFormatDetection = 'email_address_invalid_email_format_detection',

  IdAamvaDatabaseLookup = 'id_aamva_database_lookup',
  IdAccountComparison = 'id_account_comparison',
  IdAgeComparison = 'id_age_comparison',
  IdAgeInconsistencyDetection = 'id_age_inconsistency_detection',
  IdAttributeComparison = 'id_attribute_comparison',
  IdBarcodeDetection = 'id_barcode_detection',
  IdBarcodeInconsistencyDetection = 'id_barcode_inconsistency_detection',
  IdBlurDetection = 'id_blur_detection',
  IdColorInconsistencyDetection = 'id_color_inconsistency_detection',
  IdCompromisedDetection = 'id_compromised_detection',
  IdCornerDetection = 'id_corner_detection',
  IdDamagedDetection = 'id_damaged_detection',
  IdDisallowedCountryDetection = 'id_disallowed_country_detection',
  IdDisallowedTypeDetection = 'id_disallowed_type_detection',
  IdDoubleSideDetection = 'id_double_side_detection',
  IdElectronicReplicaDetection = 'id_electronic_replica_detection',
  IdEntityDetection = 'id_entity_detection',
  IdExperimentalModelDetection = 'id_experimental_model_detection',
  IdExpiredDetection = 'id_expired_detection',
  IdExtractedPropertiesDetection = 'id_extracted_properties_detection',
  IdExtractionInconsistencyDetection = 'id_extraction_inconsistency_detection',
  IdFabricationDetection = 'id_fabrication_detection',
  IdGlareDetection = 'id_glare_detection',
  IdHandwritingDetection = 'id_handwriting_detection',
  IdInconsistentRepeatDetection = 'id_inconsistent_repeat_detection',
  IdInquiryComparison = 'id_inquiry_comparison',
  IdMrzDetection = 'id_mrz_detection',
  IdMrzInconsistencyDetection = 'id_mrz_inconsistency_detection',
  IdNumberFormatInconsistencyDetection = 'id_number_format_inconsistency_detection',
  IdPaperDetection = 'id_paper_detection',
  IdPhysicalTamperDetection = 'id_physical_tamper_detection',
  IdPoBoxDetection = 'id_po_box_detection',
  IdPortraitClarityDetection = 'id_portrait_clarity_detection',
  IdPortraitDetection = 'id_portrait_detection',
  IdPublicFigureDetection = 'id_public_figure_detection',
  IdRealIdDetection = 'id_real_id_detection',
  IdRepeatDetection = 'id_repeat_detection',
  IdSelfieComparison = 'id_selfie_comparison',
  IdTamperDetection = 'id_tamper_detection',
  IdUnprocessableSubmissionDetection = 'id_unprocessable_submission_detection',
  IdValidDatesDetection = 'id_valid_dates_detection',
  IdVideoQualityDetection = 'id_video_quality_detection',

  // Gov Id Nfc type checks.
  IdNfcAttributeComparison = 'id_nfc_attribute_comparison',
  IdNfcDisallowedCountryDetection = 'id_nfc_disallowed_country_detection',
  IdNfcExpiredDetection = 'id_nfc_expired_detection',
  IdNfcPkiFailureDetection = 'id_nfc_pki_failure_detection',
  IdNfcTamperDetection = 'id_nfc_tamper_detection',
  IdNfcUnprocessableSubmissionDetection = 'id_nfc_unprocessable_submission_detection',

  MobileDriversLicenseAgeComparison = 'mobile_drivers_license_age_comparison',

  PhoneNumberConfirmationCodeComparison = 'phone_number_confirmation_code_comparison',
  PhoneNumberTimeoutDetection = 'phone_number_timeout_detection',
  PhoneNumberServiceAvailableDetection = 'phone_number_service_available_detection',
  PhoneNumberDisallowedCountryDetection = 'phone_number_disallowed_country_detection',
  PhoneNumberDeliverableDetection = 'phone_number_deliverable_detection',
  PhoneNumberInvalidNumberFormatDetection = 'phone_number_invalid_number_format_detection',

  SelfieAccountComparison = 'selfie_account_comparison',
  SelfieAgeComparison = 'selfie_age_comparison',
  SelfieAgeInconsistencyDetection = 'selfie_age_inconsistency_detection',
  SelfieAgeThresholdComparison = 'selfie_age_threshold_comparison',
  SelfieAttributeComparison = 'selfie_attribute_comparison',
  SelfieExperimentalModelDetection = 'selfie_experimental_model_detection',
  SelfieFaceCoveringDetection = 'selfie_face_covering_detection',
  SelfieGlareDetection = 'selfie_glare_detection',
  SelfieGlassesDetection = 'selfie_glasses_detection',
  SelfieIdComparison = 'selfie_id_comparison',
  SelfieImageQualityDetection = 'selfie_image_quality_detection',
  SelfieLivenessDetection = 'selfie_liveness_detection',
  SelfieMultipleFacesDetection = 'selfie_multiple_faces_detection',
  SelfiePortraitQualityDetection = 'selfie_portrait_quality_detection',
  SelfiePoseDetection = 'selfie_pose_detection',
  SelfiePoseRepeatDetection = 'selfie_pose_repeat_detection',
  SelfiePublicFigureDetection = 'selfie_public_figure_detection',
  SelfieRepeatDetection = 'selfie_repeat_detection',
  SelfieSuspiciousEntityDetection = 'selfie_suspicious_entity_detection',
  SelfieVideoQualityDetection = 'selfie_video_quality_detection',
  SelfieSimilarBackgroundDetection = 'selfie_similar_background_detection',
}

export function getChecks(type: VerificationTemplateVersion['type']): CheckName[] {
  const CHECK_NAMES_ARRAY = Object.values(CheckName) as CheckName[];
  const CHECK_TYPES_ARRAY = Object.values(CheckType);

  const checkType = VERIFICATION_TYPE_CHECK_TYPE[VTMPLV_VERIFICATION_TYPE_MAP[type]];

  // Find all supersets of this check type (e.g. digital_id => [digital_id_one_id, digital_id_singpass, digital_id_uk_sharecode...])
  const checkTypeSuperSetPrefixes = CHECK_TYPES_ARRAY.filter(
    (ct) => ct.includes(checkType) && ct !== checkType,
  );

  return CHECK_NAMES_ARRAY.filter((checkName) => {
    return (
      checkName.startsWith(checkType) &&
      checkTypeSuperSetPrefixes.every((prefix) => !checkName.startsWith(prefix))
    );
  });
}

export function needsBiometricsProcessing(checkName: CheckName): boolean {
  // NOTE: IdAccountComparison has some Biometrics usage, but can run without Biometrics.
  // In the front-end, we show the Biometrics chip, but app/models/verification/check/government_id/account_comparison.rb
  // does not get disabled by default if biometrics is disabled: the non-biometrics parts still run.
  if (checkName === CheckName.IdAccountComparison) {
    return true;
  }
  const dependentFeatures = CHECK_PROPERTIES[checkName]['dependent_features'] as string[];
  return dependentFeatures.includes('biometrics_processing');
}

export function needsBiometricsStorage(checkName: CheckName): boolean {
  const dependentFeatures = CHECK_PROPERTIES[checkName]['dependent_features'] as string[];
  return dependentFeatures.includes('biometrics_storage');
}
